<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ "globals.update" | translate }} <span *ngIf="title">{{ title }}</span>
  </h4>
</div>
<ng-container>
  <div class="modal-body">
    <ng-container>
      <form [formGroup]="developmentFormGroup">
        <div class="form-group">
          <label class="mainColorText" for="devInputName">{{
            "form.devName" | translate
          }}</label>
          <input
            id="devInputName"
            type="text"
            class="form-control"
            formControlName="name"
            [placeholder]="'form.name' | translate"
          />
        </div>
        <div class="form-group" style="display: none">
          <input
            type="text"
            class="form-control"
            formControlName="description"
            [placeholder]="'form.infoExtra' | translate"
          />
        </div>
      </form>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn cancelar" (click)="onDismiss()">
      {{ "globals.buttons.cancelar" | translate }}
    </button>
    <button
      type="button"
      (click)="updateDevelopment()"
      class="btn acceptButton"
      [disabled]="developmentFormGroup.invalid"
    >
      {{ "globals.buttons.save" | translate }}
    </button>
  </div>
</ng-container>
